<template>
    <div>
        <component :is="forHistoryPage ? 'div' : TheModalTitle" container-class="" :model-value="modelValue"
            :backdrop="backdrop" @update:model-value="onModelValue">
            <template #header v-if="!forHistoryPage">
                <span class="text-[24px] leading-10">
                    {{ `${$t('History')}` }}
                </span>
            </template>
            <div class="w-full">
                <div class="my-1 text-[#93acd3]">{{$t('game.statisticsTitle')}}</div>
                <div class="flex justify-between items-center mb-[10px]">
                    <div class="flex items-center gap-[10px]">
                        <div class="flex flex-col items-center">
                            <UserAvatar class="shrink-0" size="42px" self />
                            <div
                                class="text-[6.6px] text-white font-[800] leading-[12px] pl-[6px] pr-[8px] bg-red rounded-[24px] mt-[-5px]">
                                {{ userStore.$state.lvl }} {{ $t('niuniu.rank') }}</div>
                        </div>
                        <span class="text-[14px] text-[var(--Text-Secondary)] font-[600] leading-[12px]">{{ userStore.name
                        }}</span>
                    </div>
                    <div class="flex items-center gap-[5px]">
                        <CurrentCoin class="!w-[24px] !h-[24px]" :name="userStore.$state.currentCurrency" />
                        <span class="text-[24px] text-white font-[600] leading-[24px]">
                            {{ totalWinAmount.toFixed(2) === '0.00' ? '0.00' : (totalWinAmount > 0 ? '+' + totalWinAmount.toFixed(2) :
                                totalWinAmount.toFixed(2)) }}
                        </span>
                    </div>
                </div>
                <div class="big-list gray-box">
                    <q-table
                        key="collecting"
                        v-bind="oTableSetting"
                        row-key="index"
                        :no-data-label="$t('niuniu.noHistoryData')"
                        :rows="forHistoryPage ? list : displayList"
                        :columns="oTableData.aColumns"
                        table-class=""
                        :class="{
                            [forHistoryPage ? '' : 'h-[300px]']: true,
                        }"
                    >
                                <template v-slot:body="props">
                                    <q-tr :props="props">
                                        <q-td class="td-time" key="time">
                                            <div class="td-inner">
                                                <span class="text" v-html="props.row.time"></span>
                                            </div>
                                        </q-td>
                                        <q-td class="td-room" key="room">
                                            {{ getHallName(props.row.rawData?.hall_name) }}
                                        </q-td>
                                        <q-td class="td-amount" key="betting">
                                            <div class="td-inner">
                                                <CurrentCoin size="18px" class="mr-[5px] shrink-0" :name="props.row.rawData.currency" />
                                                <span class="text text-green">
                                                    {{ props.row.betting }}
                                                </span>
                                            </div>
                                        </q-td>
                                        <q-td class="td-amount" key="winOrLose">
                                            <div class="td-inner">
                                                <CurrentCoin size="18px" class="mr-[5px] shrink-0" :name="props.row.rawData.currency" />
                                                <span class="text" :class="[props.row.winOrLose.startsWith('-') ? 'text-white' : 'text-green']">
                                                    {{ props.row.winOrLose }}
                                                </span>
                                            </div>
                                        </q-td>
                                        <q-td class="td-btn" key="detail">
                                            <button class="see-deail" @click.prevent="fnSeeDetail(props.row)">
                                                <IconSvgUse use="icon-arrow-right-small" size="16px" />
                                            </button>
                                        </q-td>
                                    </q-tr>
                                </template>
                                <template v-slot:no-data="{ message }">
                                    <div class="loading-box" v-if="isLoading">
                                        <IconSvgUse use="icon-loading" size="30px" class="animate-spin" />
                                    </div>
                                    <div class="no-data-message" v-else>
                                        <img class="no-data-pic" src="../img/no-data.png" alt="" />
                                        <p class="no-data-tips">
                                            {{ message }}
                                        </p>
                                    </div>
                                </template>
                    </q-table>
                    <div class="history-pagination" v-if="forHistoryPage">
                        <q-pagination v-model="oTableData[oTabs.collecting].pageConfig.page" :max="Math.ceil(
                            oTableData[oTabs.collecting].total
                            / oTableData[oTabs.collecting].pageConfig.page_size
                        )" :max-pages="4" boundary-numbers color="[#55657e]" active-color="[#2281f6]"
                            direction-links @update:model-value="(iPageNo) => fnTableDataLoader(iPageNo)" />
                    </div>
                </div>
                <!-- ↓ 最后的提示文字 -->
                <p class="bottom-tips" v-if="!forHistoryPage">
                    {{ $t('niuniu.viewRecords') }}
                </p>
            </div>
        </component>
    </div>

    <!-- 
        ↓ 以下是窗口 
    -->
    <ClientOnly>
        <!-- ↓ 浮层页专用，另外在游戏内部时是通过修改 route 参数触发弹出游戏详情，不依赖此处的组件 -->
        <NiuNiuHistoryDetail v-if="forHistoryPage" :gameDropValue="'niuniu'" :historyDetail="oHistoryQuery" />
    </ClientOnly>
    <!-- ↓ 历史“详情” 窗口，在此监听 route 参数变化并打开 -->
    <CasinoHistoryModalGameDetali :gameDropValue="'niuniu'" />
</template>

<script setup lang="ts">
import TheModalTitle from '@/components/Modal/Title.vue';
import NiuNiuHistoryDetail from '@/components/Casino/History/Modal/GameDetali/index.vue';
import { useUserStore } from '~/stores/user';
import { useRatesStore } from '~/stores/cansino/rates';
import { useNiuNiu } from '~/socket/game/niuniu';
const { EMIT_NIUNIU_USER_HISTORY } = useNiuNiu();

const userStore = useUserStore();
const rates = useRatesStore();
const { t: $tFn, locale } = useNuxtApp().$i18n;

const props = defineProps({
    modelValue: Boolean, // 
    forHistoryPage: {
        type: Boolean,
        default: false,
    },
    backdrop: {
        type: Boolean,
        default: true,
    },
})
const emit = defineEmits(['update:modelValue'])

// 用户历史记录数据
const list = ref([]);
const totalWinAmount = ref(0);
const isLoading = ref(false);

// 限制显示的列表数据（forHistoryPage为true时最多显示20条）
const displayList = computed(() => {
    if (!props.forHistoryPage && list.value.length > 20) {
        return list.value.slice(0, 20);
    }
    return list.value;
});

const oHistoryQuery = ref({}) //查看历史详情所带参数
const originalQueryBeforeDetail = ref(null) // 保存打开详情前的完整 query

// 分页数据结构
const oTabs = {
    collecting: 'collecting'
};

const oTableSetting = {
    'pagination': {
        rowsPerPage: props.forHistoryPage ? 50 : 20,
    },
    'hide-pagination': !!1,
    'class': 'big-table',
};

const oTableData = reactive({
    aColumns: [
        {
            label: $tFn('niuniu.time'),
            name: 'time',
            field: 'time',
        },
        {
            label: $tFn('niuniu.room'),
            name: 'room',
            field: 'room',
        },
        {
            label: $tFn('niuniu.bet'),
            name: 'betting',
            field: 'betting',
        },
        {
            label: $tFn('niuniu.winOrLoss'),
            name: 'winOrLose',
            field: 'winOrLose',
        },
        {
            label: '',
            name: 'detail',
            field: 'detail',
        },
    ],
    collecting: {
        pageConfig: {
            page: 1,        // 当前页码
            page_size: props.forHistoryPage ? 50 : 20   // 每页数量
        },
        total: 0           // 总记录数
    }
});

// 将时间戳转换为格式化的日期时间字符串
const formatTimestamp = (timestamp) => {
    let date;

    // 判断是否为ISO 8601格式字符串（如："2025-09-30T04:51:10.000Z"）
    if (typeof timestamp === 'string' && timestamp.includes('T')) {
        date = new Date(timestamp);
    } else {
        // 兼容原有的时间戳格式（秒）
        date = new Date(timestamp * 1000);
    }

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    if (locale.value === 'cn') {
        // 中文格式：2025/10/07 换行 19:02:17
        const datePart = `${year}/${month}/${day}`;
        const timePart = `${String(hours).padStart(2, '0')}:${minutes}:${seconds}`;
        return `${datePart}<br>${timePart}`;
    } else {
        // 英文格式：10/07/2025 换行 07:02:17 PM
        const datePart = `${month}/${day}/${year}`;
        const hour12 = hours % 12 || 12;
        const ampm = hours >= 12 ? 'PM' : 'AM';
        const timePart = `${String(hour12).padStart(2, '0')}:${minutes}:${seconds} ${ampm}`;
        return `${datePart}<br>${timePart}`;
    }
};

// 获取房间名称的翻译
const getHallName = (hallName) => {
    const hallMap = {
        'trial': $tFn('niuniu.hall01'),
        'casual': $tFn('niuniu.hall02'),
        'premium': $tFn('niuniu.hall03')
    };
    return hallMap[hallName] || hallName;
};

// 根据状态格式化输赢金额
const formatWinAmount = (winAmount) => {
    const amount = parseFloat(winAmount);
    if (amount > 0) {
        return Math.abs(amount).toFixed(2);
    } else if (amount === 0) {
        return '0.00';
    } else {
        return '-' + Math.abs(amount).toFixed(2);
    }
};

// 格式化记录数据为组件所需格式
const formatHistoryData = (data) => {
    return data.map((item, index) => ({
        index,
        time: formatTimestamp(item.timestamp),
        sessions: `${item.hallName} (${item.rateType})`,
        betting: item.amount,
        winOrLose: formatWinAmount(item.winAmount - item.amount),
        // 保存原始数据，用于详情显示
        rawData: item
    }));
};

// 计算总输赢金额（参照红包游戏逻辑，支持货币转换）
const calculateTotalWinAmount = (data) => {
    const sNowCurrency = userStore.currentCurrency; // 当前用户货币
    const oRates = rates.comparisonCurrencyList; // 汇率对照表

    return data.reduce((total, item) => {
        // 如果item没有currency字段，跳过此条记录
        if (!item.currency) {
            console.warn('[牛牛历史] 记录缺少currency字段:', item);
            return total;
        }
        
        // 构建汇率键名：item.currency + sNowCurrency
        const sRule = item.currency + sNowCurrency;
        
        // 计算汇率：如果货币相同为1，否则从汇率表获取
        let fRate = (
            item.currency === sNowCurrency
            ? 1
            : oRates[sRule]
        );
        
        // 如果汇率不存在或为undefined/null，跳过此条记录并警告
        if (!fRate || isNaN(fRate)) {
            console.log('[牛牛历史] 汇率不存在:', {
                fromCurrency: item.currency,
                toCurrency: sNowCurrency,
                rateKey: sRule,
                availableRates: Object.keys(oRates)
            });
            return total;
        }
        
        // 累加转换后的金额：winAmount * 汇率
        const winAmount = parseFloat(item.winAmount || 0);
        const convertedAmount = winAmount * fRate;
        return total + convertedAmount;
    }, 0);
};

// 获取用户历史记录
const fetchUserHistory = (pageNo = 1) => {
    isLoading.value = true;
    list.value = [];

    // 使用指定参数调用接口，支持分页
    const params = {
        game: "22",
        category: "dapps",
        page: pageNo,
        limit: oTableData.collecting.pageConfig.page_size
    };

    // 使用回调式调用socket方法
    EMIT_NIUNIU_USER_HISTORY(params, (res) => {
        isLoading.value = false;
        if (!res || res['error'] || !res['response']) {
            console.error('❌ 获取历史数据失败:', res?.error);
            return;
        }

        if (Array.isArray(res.response)) {
            // 保存总记录数
            oTableData.collecting.total = res.count || 0;

            // API返回的是数组格式
            totalWinAmount.value = calculateTotalWinAmount(res.response);
            list.value = formatHistoryData(res.response);
        } else {
            // 处理错误情况
            list.value = [];
            totalWinAmount.value = 0;
            oTableData.collecting.total = 0;
        }
    });
};

// 分页切换处理函数
const fnTableDataLoader = (pageNo) => {
    oTableData.collecting.pageConfig.page = pageNo;
    fetchUserHistory(pageNo);
};

/**
 * 查看历史的详情
 */
const fnSeeDetail = (oTarget) => {
    const route = useRoute();
    const router = useRouter();
    
    // 保存当前完整的 query（包含 name）
    originalQueryBeforeDetail.value = { ...route.query };
    
    // 打开详情时的 query，保留 name 参数以避免游戏重置
    const query = {
        modal: 'BetDetails',
        data: `niuniu:${oTarget.rawData._id}`,
        ...(route.query.name && { name: route.query.name }), // 保留 name 参数
    };
    
    if (props.forHistoryPage) {
        oHistoryQuery.value = query;
        return;
    }

    router.push({
        replace: true,
        path: route.path,
        query,
    });
}

const onModelValue = (value) => {
    emit('update:modelValue', !!value)
}

// ↓监听窗口自身的打开 
watch(() => props.modelValue, async (isShowing) => {
    if (
        import.meta.server
        || !isShowing
        || props.forHistoryPage
    ) {
        return;
    }
    fetchUserHistory();
}, {
    immediate: true,
});

// 🔄 监听详情窗口的关闭（通过 route.query.modal 的变化）
watch(() => useRoute().query.modal, (newModal, oldModal) => {
    // 如果是在历史页面，不处理
    if (props.forHistoryPage || import.meta.server) {
        return;
    }
    
    // 当 modal 从 'BetDetails' 变为空时，表示详情窗口关闭
    if (oldModal === 'BetDetails' && !newModal && originalQueryBeforeDetail.value) {
        const router = useRouter();
        const route = useRoute();
        
        // 恢复原始的完整 query
        router.replace({
            path: route.path,
            query: originalQueryBeforeDetail.value,
        });
        
        // 清空保存的原始 query
        originalQueryBeforeDetail.value = null;
    }
});

onMounted(() => {
    if (props.forHistoryPage) {
        fetchUserHistory();
    }
});
</script>
<style lang="scss" scoped>
.gray-box {
    background: rgba(32, 42, 57, 1);
    padding: 12px;
    border-radius: 8px;
}

.big-list {
    & :deep(.q-table__card) {
        background-color: transparent;
        box-shadow: none;
    }
    & :deep(table.q-table) {
        width: 100%;
        overflow: hidden;
        background-color: transparent;
        tr {
            border-bottom: solid 1px rgba(255, 255, 255, 0.15);
        }
        tbody tr:hover {
            background-color: rgb(0, 0, 0, 0.1);
        }
        th {
            color: rgba(85, 101, 126, 1);
            font-size: 12px;
            text-align: left;
            padding: 0 3px;
            font-weight: 500;
        }
        td {
            opacity: 1;
            padding: 0 3px;
        }
    }
    td .td-inner {
        font-size: 14px;
        line-height: 14px;
        vertical-align: middle;
        display: flex;
        align-items: center;
        overflow: hidden;
        max-width: 99%;
        min-height: 48px;
        .text {
            min-width: 10px;
        }
    }
    .td-room {
        color: white;
        font-weight: 500;
        font-size: 14px;
        min-width: 65px;
    }
    .td-amount {
        color: rgba(167, 181, 202, 1);
        min-width: 65px;
        font-weight: 700;
        .text-green {
            color: rgba(27, 184, 61, 1);
        }
    }
    .td-time {
        .text {
            color: rgba(167, 181, 202, 1);
            font-weight: 600;
            font-size: 12px;
        }
    }
    .td-btn {
        button.see-deail {
            background: rgba(68, 88, 116, 0.24);
            color: rgba(151, 151, 151, 1);
            width: 20px;
            height: 20px;
            border-radius: 5px;
            display: flex;
            justify-content: center;
            align-items: center;
            &:hover,
            &:active {
                opacity: 0.9;
            }
            .q-icon {
                margin: 0;
                display: inline-block;
                opacity: 0.7;
            }
        }
    }
}

.history-pagination {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: 20px;
    margin-top: 20px;

    :deep(.q-pagination) {
        button {
            background: #545c6c40;
            color: #55657e;
            border-radius: 10px;
            font-size: 14px;
            font-weight: 600;
            height: 35px;
            min-width: 35px !important;
            margin: 0 2px;
        }

        .q-btn--standard {
            background: #2281f6;
            font-size: 15px;
        }
    }
}

.loading-box {
    min-height: 150px;
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 45px 0 0;
}

.no-data-message {
    min-height: 150px;
    width: 100%;
    padding: 20px;
    text-align: center;
    .no-data-pic {
        width: 165px;
        margin: 0 auto 0;
    }
    .no-data-tips {
        font-size: 14px;
        color: rgba(167, 181, 202, 1);
    }
}

.bottom-tips {
    text-align: center;
    color: rgba(167, 181, 202, 1);
    font-weight: 400;
    font-size: 14px;
    line-height: 14px;
    vertical-align: middle;
    padding: 0.8em 0 0;
}
</style>